export function guessCRS(x, y) {
  const candidates = [];

  // EPSG:4326 (WGS84 위경도)
  if (x >= 124 && x <= 132 && y >= 33 && y <= 39) {
    candidates.push("EPSG:4326 (WGS84 위경도)");
  }

  // EPSG:3857 (Web Mercator)
  if (x >= 13800000 && x <= 14700000 && y >= 3900000 && y <= 5500000) {
    candidates.push("EPSG:3857 (WGS84 Web Mercator)");
  }

  // EPSG:5186 (Korea 2000 Unified CS)
  if (x >= 100000 && x <= 400000 && y >= 400000 && y <= 600000) {
    candidates.push("EPSG:5186 (Korea 2000 Unified CS)");
  }

  // EPSG:5179 (Korea 2000 / Central Belt)
  if (x >= 150000 && x <= 350000 && y >= 3800000 && y <= 4200000) {
    candidates.push("EPSG:5179 (Korea 2000 / Central Belt)");
  }

  // EPSG:5181 ~ 5187 (Regional Belts)
  if (x >= 200000 && x <= 800000 && y >= 3500000 && y <= 4500000) {
    candidates.push("EPSG:5181~5187 (Korea 2000 Regional Belts)");
  }

  // EPSG:5174 ~ 5178 (Regional Belts - 다른 세트)
  if (x >= 200000 && x <= 800000 && y >= 3500000 && y <= 4500000) {
    candidates.push("EPSG:5174~5178 (Korea 2000 Regional Belts 구버전)");
  }

  // EPSG:32650 (UTM Zone 50N - 제주 일부)
  if (x >= 250000 && x <= 750000 && y >= 3600000 && y <= 3900000) {
    candidates.push("EPSG:32650 (UTM Zone 50N)");
  }

  // EPSG:32651 (UTM Zone 51N - 서쪽 지역)
  if (x >= 200000 && x <= 800000 && y >= 3700000 && y <= 4200000) {
    candidates.push("EPSG:32651 (UTM Zone 51N)");
  }

  // EPSG:32652 (UTM Zone 52N - 동쪽 지역)
  if (x >= 200000 && x <= 800000 && y >= 3700000 && y <= 4200000) {
    candidates.push("EPSG:32652 (UTM Zone 52N)");
  }

  // EPSG:2096 ~ 2098 (Tokyo Datum / Bessel 구좌표)
  if (x >= 200000 && x <= 800000 && y >= 0 && y <= 1500000) {
    candidates.push("EPSG:2096~2098 (Tokyo Datum / Bessel 구좌표)");
  }

  if (candidates.length === 0) {
    return "좌표계 후보를 찾지 못했습니다.";
  }

  return candidates;
}
